<template>

<section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>

    <section>

      <div class=" topcontainer">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-8">
            <div v-html="oprsleftsidetext" class="formatlefttext"></div>
            <IntFrame :pdfiframe="opresrptdocument1" pdfviewtheme="pdfviewcss" />

            <div v-for="ddocs in opresrptdocument">
              <div ><a :href="`${myPicUrl}${ddocs.opresrptdocument}`">{{ ddocs.opdownloaddesc}} <i class="fa-solid fa-download"></i></a>
              </div>
           </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4">
            <div class="card shadow">
              <div v-html="oprsrightsidetext"></div>
              <div>
                <canvas id="myChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="tmmessage">
      <div class="container bottomtext col-xs-12 col-sm-12">
        <p  v-html="oprsbottomtext">
        </p>
      </div>
    </section>


</template>

<script>

import IntFrame from '@/components/IntFrame.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/globalDeclare.js');
require('@/assets/css/video-js.css');
import Chart from 'chart.js/auto';
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
 Chart, IntFrame
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  contdata: [],

  //OPS all reserve data
  oprshowrdesc: '',
  oprsleftsidetext: '',
  oprsrightsidetext: '',
  oprsbottomtext: '',

  //reserve downloads
  opdownloaddesc: '',
  opresrptdocument1: '',
  opresrptdocument: [],
  myPicUrl: '',

  height: 0,
  width: 0,
  }
},
methods: {

},

async mounted() {
  this.myPicUrl = myUrlPath
 
axios.get('allpagespv/opsoverview').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })

//------------Operations products page Cards ---------------
await axios.get('getopspagereserves/').then(
    response => { 
    this.oprsleftsidetext = response.data[0].oprsleftsidetext
    this.oprshortdesc = response.data[0].oprshortdesc
    this.oprsrightsidetext = response.data[0].oprsrightsidetext
    this.oprsbottomtext = response.data[0].oprsbottomtext
    console.log(response.data)
  })
  .catch((error) => {
      console.log(error)
    }) 

    //------------Operations products page Cards ---------------
await axios.get('getopspagereservesdownloads/').then(
    response => { 
    this.opresrptdocument = response.data.opdownloaddesc
    this.opresrptdocument1 =  this.myPicUrl +  response.data[0].opresrptdocument
    console.log(this.opresrptdocument1)
  })
  .catch((error) => {
      console.log(error)
    }) 


//------------Operations products page Cards ---------------
await axios.get('getsilversupplygraphdata/reserveresources').then(
    response => { 
    this.opssilversupplygraphlabels = response.data.rlabels
    this.opssilversupplygraphdata = response.data.rdata

    const ctx = document.getElementById('myChart');
    const myChart1 = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: this.opssilversupplygraphlabels,
        datasets: [{
            label: 'Total: ',
            data: this.opssilversupplygraphdata,
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)'
            // 'rgba(153, 102, 255, 0.2)',
            // 'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'
            // 'rgba(153, 102, 255, 1)',
            // 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            hoverOffset: 24,
            responsive: true,
            // maintainAspectRatio: true,
            resizeDelay: 0
            // radius: 100,
            
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      // layout: {
      //       padding: 30
      //   },
      responsive: true,
      // aspectRatio: 1.4,
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart1;
 
  })
  .catch((error) => {
      console.log(error)
    }) 
    
}
}
</script>

<style scoped>

.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.card {
  padding: 30px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}


/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

 
  .tmmessage {
    margin-top: 100px;
    margin-bottom: -500px;
  }

  .topcontainer {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 250px;
  }
  .pdfviewcss {
    margin-top: 80px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .graphcss {
    margin-top: 100px;
  }
 
  .tmmessage {
    margin-top: 100px;
    margin-bottom: -500px;
  }

  .topcontainer {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 250px;
  }
  .pdfviewcss {
    margin-top: 80px;
  }
  .card {
    padding-left: 100px;
    padding-right: 100px;
  }
 }
 
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  
  .tmmessage {
    margin-top: 100px;
    margin-bottom: -500px;
  }

  .topcontainer {
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 250px;
  }
  .pdfviewcss {
    margin-top: 80px;
  }
 .col-md-8 {
  width: 100%;
 }
 .col-md-4 {
  width: 100%;
 }
 .card {
  padding-left: 100px;
  padding-right: 100px;
}
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 100px;
    width: 800px;
    padding-right: 10px;
  }
  .col-md-8 {
    width: 70%;
   }
   .col-md-4 {
    width: 30%;
   }
   .card {
    padding: 30px;

  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .pdfviewcss {
    width: 300px;
  }
 } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {


  .fa-download {
    padding-right: 50px;
  }
  .tmmessage {
    margin-top: 100px;
    margin-bottom: -500px;
  }
  .topcontainer {
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 250px;
  }
  .pdfviewcss {
    margin-top: 80px;
  }
  .col-md-4 {
    margin-top: -100px;
  }
} 

 
</style>
